exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_groups_1MpqLDL4RBWDWNh_bD2jRe {\n  width: 100%;\n  margin-top: 20px;\n}", ""]);

// Exports
exports.locals = {
	"IA_groups": "IA_groups_1MpqLDL4RBWDWNh_bD2jRe"
};